import { render, staticRenderFns } from "./StudioEventProductCheckout.vue?vue&type=template&id=4547495f&scoped=true&"
import script from "./StudioEventProductCheckout.vue?vue&type=script&lang=js&"
export * from "./StudioEventProductCheckout.vue?vue&type=script&lang=js&"
import style0 from "./StudioEventProductCheckout.vue?vue&type=style&index=0&id=4547495f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547495f",
  null
  
)

export default component.exports